import { FaWhatsapp } from "react-icons/fa";
import { Phone, CheckCircle } from "lucide-react";

const WHATSAPP_URL = "https://wa.me/5567996508622?text=Ol%C3%A1%2C%20preciso%20de%20um%20guincho!";
const TEL_URL = "tel:+5567996508622";

export default function FinalCTA() {
  return (
    <section
      id="cta-final"
      data-testid="final-cta-section"
      className="py-24 sm:py-32 bg-[#FFD700] relative overflow-hidden"
    >
      {/* Diagonal pattern */}
      <div className="absolute inset-0 opacity-10">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: "repeating-linear-gradient(45deg, #000 0, #000 1px, transparent 0, transparent 50%)",
            backgroundSize: "20px 20px",
          }}
        />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2
          data-testid="final-cta-title"
          className="text-3xl sm:text-4xl lg:text-6xl font-black tracking-tighter uppercase text-black mb-6 leading-tight"
          style={{ fontFamily: "'Oswald', sans-serif" }}
        >
          Precisa de Guincho Agora?
        </h2>

        <p className="text-black/80 text-lg sm:text-xl mb-10 max-w-2xl mx-auto font-medium">
          Fale com nossa equipe e receba atendimento imediato!
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-whatsapp-button"
            className="inline-flex items-center justify-center gap-3 bg-[#25D366] hover:bg-[#20BD5A] text-white text-lg font-bold uppercase tracking-wide px-10 py-5 rounded-sm transition-all hover:-translate-y-1 hover:shadow-lg"
          >
            <FaWhatsapp className="w-6 h-6" />
            Chamar no WhatsApp
          </a>
          <a
            href={TEL_URL}
            data-testid="final-call-button"
            className="inline-flex items-center justify-center gap-3 bg-black hover:bg-[#1A1A1A] text-white text-lg font-bold uppercase tracking-wide px-10 py-5 rounded-sm transition-all hover:-translate-y-1 hover:shadow-lg"
          >
            <Phone className="w-6 h-6" />
            Ligar Agora
          </a>
        </div>

        {/* Trust badges */}
        <div className="flex flex-wrap items-center justify-center gap-6 text-black/70">
          {["Atendimento 24h", "Preco Justo", "Chegada Rapida"].map((t) => (
            <div key={t} className="flex items-center gap-2">
              <CheckCircle className="w-5 h-5" />
              <span className="text-sm font-bold uppercase">{t}</span>
            </div>
          ))}
        </div>

        <p className="mt-8 text-black/60 text-sm font-medium uppercase tracking-wider">
          Mais de diversos atendimentos realizados com sucesso na regiao!
        </p>
      </div>
    </section>
  );
}
